/** @format */

import {format} from 'date-fns';

import {SensorCategoriesCriteriaType} from 'types';

import {DEFAULT_SENSORS_STAT} from '../const';
import {CurrentCompanyType, GraphSensorCheckType} from '../../types';
import {getSensorGroup} from './getSensorGroup';

export interface SensorsStat {
  sensors: string[];
  foundAtPeriodStart: number;
  foundNew: number;
  foundFixed: number;
  leftAtPeriodEnd: number;
}

export interface SensorsStatOptions {
  categoryName: SensorCategoriesCriteriaType;
  currentCompany?: CurrentCompanyType;
  startDate: Date;
  endDate: Date;
}

const getSensorsStat = ({
  categoryName,
  currentCompany,
  startDate,
  endDate,
}: SensorsStatOptions): SensorsStat => {
  if (!currentCompany) {
    return DEFAULT_SENSORS_STAT;
  }

  const {graphSensorChecks, sensorGroups} = currentCompany;
  const sensors = getSensorGroup(sensorGroups, categoryName);

  const startDateFormatted = format(startDate, 'yyyy-MM-dd');
  const endDateFormatted = format(endDate, 'yyyy-MM-dd');
  const startDateChecks: GraphSensorCheckType[] = [];
  const endDateChecks: GraphSensorCheckType[] = [];

  const filteredChecks = graphSensorChecks.filter(check => {
    if (sensors.includes(check.sensorName)) {
      // Дополнительно нужно сохранить проверки, относящиеся к датам начала и конца периода
      if (check.collectedOn === startDateFormatted) {
        startDateChecks.push(check);
      } else if (check.collectedOn === endDateFormatted) {
        endDateChecks.push(check);
      }
      return true;
    }
    return false;
  });

  const foundAtPeriodStart = startDateChecks.reduce((acc, cur) => acc + cur.old, 0);
  const foundNew = filteredChecks.reduce((acc, cur) => acc + cur.new, 0);
  const foundFixed = filteredChecks.reduce((acc, cur) => acc + cur.fixed, 0);
  const leftAtPeriodEnd = endDateChecks.reduce((acc, cur) => acc + cur.old + cur.new, 0);

  return {
    sensors,
    foundAtPeriodStart,
    foundNew,
    foundFixed,
    leftAtPeriodEnd,
  };
};

export {getSensorsStat};
